import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/banner/banner-single-course.jpg")